import { ImageSlot } from '@/components/ImageUploader/ImageUploader';
import { CarImageDTO } from '@/openapi';

export const fileToBase64 = (file: File): Promise<string> =>
	new Promise((resolve, reject) => {
		const reader = new FileReader();
		reader.readAsDataURL(file);
		reader.onload = () => resolve(reader.result as string);
		reader.onerror = () => reject(reader.error);
	});

export const imageSlotToDTO = async (slot: ImageSlot): Promise<CarImageDTO> => {
	if (!slot.file) {
		throw new Error('File not found in image slot');
	}

	const dataUrl = await fileToBase64(slot.file);
	// dataUrl = "data:image/png;base64,iVBORw0KGgoAAAANS..."
	const [meta, base64] = dataUrl.split(',');
	// estraggo contentType da "data:image/png;base64"
	const match = meta.match(/data:(.+);base64/);
	const srcContentType = match ? match[1] : slot.file.type;

	return {
		src: base64,
		srcContentType
	};
};

/**
 * Formatta un prezzo aggiungendo il separatore delle migliaia
 * @param price - Il prezzo da formattare (number, string o undefined)
 * @returns Il prezzo formattato con il separatore delle migliaia e virgola per i decimali
 */
export const formatPriceWithThousandsSeparator = (price: number | string | undefined): string => {
	if (price === undefined) {
		return '0';
	}

	// Converte in stringa se è un numero
	const priceStr = price.toString();

	// Separa la parte intera da quella decimale (gestisce sia punto che virgola)
	const [integerPart, decimalPart] = priceStr.split(/[.,]/);

	// Aggiunge il separatore delle migliaia alla parte intera
	const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, '.');

	// Se non ci sono decimali o sono "00", ritorna solo la parte intera
	if (!decimalPart || decimalPart === '00') {
		return formattedInteger;
	}

	// Ricompone il prezzo con la virgola per i decimali
	return `${formattedInteger},${decimalPart}`;
};
